<template>
    <div
        class="product-box-wrapper fill-height"
        @mouseover="displayWishlistButton = true"
        @mouseleave="displayWishlistButton = false"
    >
        <wishlist-button
            class="wishlist-button-tooltip"
            :productId="product.id"
            buttonColor="info lighten4"
            buttonActiveColor="primary"
            :show-button="displayWishlistButton"
        />

        <div class="badges">
            <v-chip v-if="priceData.discount" label color="primary" text-color="white" class="discount-badge">
                -{{ discountRate }}%
            </v-chip>
            <img
                v-if="isEngravingProduct"
                class="engraving-badge"
                src="@/assets/engraving_badge_black_33x33.png"
                alt="grill-gravur"
            />
        </div>

        <reminder-product-availability
            v-if="quota <= 0"
            class="reminder_chip"
            :product="product"
            depressed
            :round="false"
            :triggerElement="triggerElement"
        ></reminder-product-availability>

        <v-card class="product-box" hover :to="getProductUrl(product)" flat>
            <v-layout column ma-0 class="fill-height">
                <v-flex shrink pa-0>
                    <v-img
                        :src="product.images.default.medium"
                        :aspect-ratio="1/1"
                        :lazy-src="product.images.default.placeholder"
                        contain
                    />
                    <div class="caption heading-font font-weight-bold px-2 pt-1 primary--text">{{ marke }}</div>
                    <div class="py-1 px-2">
                        <div class="subheading">
                            {{ title }}
                        </div>
                        <div class="caption text--secondary" v-if="description">
                            {{ description | striphtml | clearLineBreaks | clearExtraSpaces }}
                        </div>
                    </div>
                </v-flex>

                <v-spacer></v-spacer>
                <v-flex mb-1 px-2 v-if="product.attributes.de['mb.sku']">
                    <span class="subheading font-weight-bold">
                        SKU:
                    </span>
                    <span class="subheading text--darken-4" style="color: #666666;">
                        {{ product.attributes.de['mb.sku'] }}
                    </span>
                </v-flex>
                <v-flex shrink pa-0 :class="$vuetify.breakpoint.smAndDown ? 'mt-4' : ''">
                    <v-card-actions class="py-1 mt-2 px-2">
                        <v-layout row wrap>
                            <v-flex :xs7="product.reviewCount" :xs12="!product.reviewCount" pr-0>
                                <span class="headline mr-1" v-if="pricesAreDifferent">
                                    {{ 'Jetzt ab' | translation }}
                                </span>
                                <template v-if="priceData.original_price_inkl_vat > priceData.price">
                                    <span class="caption font-weight-bold light--text text--darken-4 d-block">
                                        <del>{{ priceData.original_price_inkl_vat | currency }}</del>
                                    </span>
                                    <span class="title heading-font">
                                        {{ priceData.price | currency }}
                                    </span>
                                </template>
                                <span class="title heading-font" v-else>
                                    {{ priceData.price | currency }}
                                </span>
                            </v-flex>
                            <v-flex xs5 pl-0 v-if="product.reviewCount">
                                <v-rating
                                    :value="product.rating"
                                    background-color="grey lighten-1"
                                    class="text-xs-right"
                                    color="yellow darken-1"
                                    dense
                                    empty-icon="$vuetify.icons.ratingFull"
                                    half-increments
                                    readonly
                                    size="18"
                                    v-if="product.reviewCount"
                                />
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-flex>
            </v-layout>
        </v-card>
    </div>
</template>

<script>
import ProductThumbnail from '@breakmedia/prime-vue-product/src/ProductThumbnail';
import ReminderProductAvailability from '@/components/product/ReminderProductAvailability';

export default {
    extends: ProductThumbnail,
    components: {
        ReminderProductAvailability,
    },
    data() {
        return {
            triggerElement: 'chip',
            displayWishlistButton: false,
        };
    },
    computed: {
        marke() {
            const brand = this.getProductAttributeByLanguage(this.product, 'mb.brand');
            if (brand && typeof brand !== 'string') {
                return Object.values(brand).join(',');
            }
            return brand;
        },
        quota() {
            const merchantProductData = this.product.merchant[Object.keys(this.product.merchant)[0]];
            return merchantProductData ? merchantProductData['quota'][this.product.id] : null;
        },
        description() {
            const description = this.getProductAttributeByLanguage(this.product, 'product.description.short');
            if (description) {
                if (this.$vuetify.breakpoint.smAndDown) {
                    return description;
                } else {
                    return description.slice(0, 200);
                }
            } else {
                return false;
            }
        },
        isEngravingProduct() {
            return this.product.attributes.de.engraving ? true : false;
        },
    },
};
</script>

<style>
.badges {
    position: absolute;
    display: grid;
    top: 10px;
    right: 10px;
    z-index: 1;
}
.discount-badge {
    margin-right: 0;
    right: unset;
    top: unset;
    position: unset;
}
.engraving-badge {
    margin-left: auto;
    position: unset;
}
</style>
